export class AlicuotasIIBB{
    id: string;
    nombreAlicuota: string;
    codigoAlicuota: number;
    valorInscripto: number;
    valorNoInscripto: number;
    valorConvenioMultilateral: number;
    baseCalculo: number;
    totalMinimo: number;
    montoPercibidoMinimo: number;
    baseImponibleMinimo: number;
    activo: boolean;
}